import { IconLayoutBottombar } from '@tabler/icons-react';

import { registerBlockPlugin } from '../../core/BlockPluginRegistry';
import type { BlockPlugin } from '../../core/types';
import { SectionPortraitBlockView } from './SectionPortraitBlockView';

export const sectionPortraitPlugin: BlockPlugin = {
    name: 'sectionPortrait',
    displayName: 'Portrait Section',
    hasData: false,
    Component: SectionPortraitBlockView,
    toolbarInsert: {
        icon: <IconLayoutBottombar size={16} />,
        title: 'Portrait Section',
        description: 'Switch to portrait orientation',
        category: 'break'
    }
};

registerBlockPlugin(sectionPortraitPlugin);
